
import React from 'react';
import MasterLicenseLayout from '@/components/masterlicense/MasterLicenseLayout';

interface MasterLicenseSettingsLayoutProps {
  children: React.ReactNode;
  isLoading: boolean;
  handleLogout: () => void;
  userRole: string;
  activeTab: string;
}

const MasterLicenseSettingsLayout: React.FC<MasterLicenseSettingsLayoutProps> = ({
  children,
  isLoading,
  handleLogout,
  userRole,
  activeTab
}) => {
  return (
    <MasterLicenseLayout
      isLoading={isLoading}
      onLogout={handleLogout}
      userRole={userRole}
      activeTab={activeTab}
    >
      <div className="p-6">
        {children}
      </div>
    </MasterLicenseLayout>
  );
};

export default MasterLicenseSettingsLayout;
